module.exports = __webpack_public_path__ + "static/3-003-81f22b30b1ce5e04672d429c732f0e8a.png";